import { useKeycloak } from "@react-keycloak/web";
import { AccessDenied } from "App";
import React, { useState, useEffect } from "react";
import { getCurrentUserProfile, getCurrentUserRole } from "shared/utils/SessionDataUtils";

// 🔐 ProtectedRoute with role-based access and error handling
export const ProtectedRoute = ({ children, requiredRoles }) => {
    const { keycloak } = useKeycloak();
    const [showError, setShowError] = useState(false);

    const userRoles = Array.isArray(getCurrentUserRole())
        ? getCurrentUserRole()
        : [getCurrentUserRole()];
    const hasAccess = keycloak?.authenticated &&
        requiredRoles.some((role) => userRoles.includes(role));
    // console.log(userRoles, requiredRoles, hasAccess);


    useEffect(() => {
        if (!hasAccess) {
            setShowError(true);
        }
    }, [hasAccess]);

    if (hasAccess) {
        return children;
    }

    if (showError) {
        return <AccessDenied />;
    }

    return null; // or a loading spinner
};

export const BETA_USERS = [
    "rajesh.biswal@gmail.com", "adityailkal@gmail.com", "rramanbabu@gmail.com", "kkr1196@gmail.com"
];

export const ADMIN_USERS = [
    "rajesh.biswal@gmail.com", "adityailkal@gmail.com"
];

// 🔐 ProtectedRoute with role-based access and error handling
export const ProtectedVisibility = ({ children, requiredRoles, beta, admin }) => {
    const { keycloak } = useKeycloak();
    const [showError, setShowError] = useState(false);

    const userRoles = Array.isArray(getCurrentUserRole())
        ? getCurrentUserRole()
        : [getCurrentUserRole()];
    let hasAccess = keycloak?.authenticated &&
        requiredRoles.some((role) => userRoles.includes(role));
    // console.log(userRoles, requiredRoles, hasAccess);
    const profile = getCurrentUserProfile();
    if (admin) {
        if (ADMIN_USERS.includes(profile.email?.toLowerCase())) {
            hasAccess = true;
        } else {
            hasAccess = false;
        }
    } else if (beta) {
        if (BETA_USERS.includes(profile.email?.toLowerCase())) {
            hasAccess = true;
        } else {
            hasAccess = false;
        }
    }

    if (children && hasAccess) {
        return children;
    }

    return hasAccess;
};
